// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Xz2TM","large":"styles_large__giiwt","medium":"styles_medium__iKQuJ"};